export default __webpack_public_path__ + "static/anita@2x-c9bc2989d81a37fbe22f3681aacf9828.png";